module.exports = __webpack_public_path__ + "img/b.ff2d8876.png";